import {ServerToken} from "../../api/types";
import {useEffect, useState} from "react";
import {agent} from "../../api/agent";
import Table, {TableColumn} from "../table/Table";
import Button from "../Button";
import {CopyValue} from "../table/CopyValue";

interface Props {
    serverId: string;
}

export default function ServerTokens({serverId}: Props) {

    const [tokens, setTokens] = useState<ServerToken[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const load = () => {
        setLoading(true);
        agent.getTokens(serverId).then((tokens) => {
            setTokens(tokens);
            setLoading(false);
        })
    }

    useEffect(() => {
        load();
    }, []);


    const columns: TableColumn[] = [
        {
            key: "name",
            label: "Name",
            render: (val, row) => <input defaultValue={val} onBlur={(ev) => {

                console.log(ev.currentTarget.value);
                agent.putToken(serverId, row.id, {
                name: ev.currentTarget.value,
            } as any as ServerToken).then(() => {
            })}}></input>
        },
        {
            key: 'token',
            label: 'Token',
            render: (val) => {
                return <div style={{width: '10rem', textOverflow: 'clip'}}><CopyValue value={val}></CopyValue></div>
            }
        },
        {
            key: 'lastUsedRepo',
            label: 'last Used',

            render: (val) => <span>{val ? val.readable : ''}</span>
        },
        {
            key: 'delete',
            label: 'Delete',
            render: (_, row) => <span style={{cursor: 'pointer'}} onClick={() => {
                agent.deleteToken(serverId, row.id).then(() => {
                    setTokens(tokens.filter(token => token.id !== row.id));
                });
            }}><i className={'fa-solid fa-trash'}></i></span>
        },
    ];

    return (
        <div>
            <h1>Server Tokens</h1>
            <Table columns={columns} data={tokens}></Table>
            <Button onClick={() => {
                agent.postToken(serverId).then((token) => {
                    setTokens([...tokens, token]);
                })
            }}><i className="fa-solid fa-plus"></i></Button>
        </div>
    );
}